var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('main',{staticClass:"application",attrs:{"id":"app"}},[_c('h-shell')],1):(_vm.isReady)?_c('main',{staticClass:"application",attrs:{"id":"app"}},[_c('h-login')],1):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }